export class Controller {

    /** @ngInject */
    constructor($state, Alert, ApplicationsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
    }

    update() {
        this.isSaving = true;
        this.ApplicationsResource
            .changeNonDomainComputerProtectionKey(this.companyId, this.application.id)
            .then(nonDomainProtectionKey => {
                this.Alert('success', 'company.manage-application.integration-developers.non-domain-protection-key.changed');
                this.application.nonDomainProtectionKey = nonDomainProtectionKey;
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.controller.js